<template>
	<div>
		<div class="mr-auto w-68 py60 merchant-profile-container" v-if="userObject">
			<form ref="form" :action="action" :method="method" @submit.prevent="validateForm">
				<figure v-if="!edit" class="mr-auto overflow-hidden image image-cover is-96x96 radius-full box-shadow has-background-white mb40" ata-aos="flip-down" data-aos-easing="linear" data-aos-duration="800">
					<lazy-load
					src="/front/img/spinner.svg"
					:lazy-src="userObject.image ? userObject.image : 'https://via.placeholder.com/96x96'"
					:lazy-srcset="userObject.image ? userObject.image : 'https://via.placeholder.com/96x96'"
					background-color="transparent"
					alt="banner"
					/>
				</figure>
				<figure v-if="edit" class="mr-auto overflow-hidden image image-contain is-96x96 radius-full box-shadow p10 mb40 profile-uploader">
					<uploader class="is-warning" name="image" label="" :file="userObject.image" :edit="false" url='/ar/merchant/image'></uploader>
				</figure>
				<h3 class="is-size-5 has-text-warning has-text-weight-bold mb30">{{t('provider_data')}}</h3>
				<div class="field is-horizontal">
					<div class="field-label is-normal">
						<label class="label" for="name">{{t('name_ar')}}</label>
					</div>
					<div class="field-body">
						<div class="field">
							<p class="mr-auto control w-80" v-if="edit">
								<input id="name_ar" name="name_ar" class="has-text-primary input line-input is-primary has-text-centered" v-model="form.name_ar" v-validate="{ required: true , min:6 ,max:30 }" :class="{'is-danger': errors.has('name_ar') }" type="text" placeholder="">
								<span v-show="errors.has('name_ar')" class="help is-danger">{{ errors.first('name_ar') }}</span>
							</p>
							<p class="mr-auto control w-80 has-text-primary has-text-weight-bold" v-else>
								{{userObject.name_ar}}
							</p>
						</div>
					</div>
				</div>
				<div class="field is-horizontal">
					<div class="field-label is-normal">
						<label class="label" for="name_en">{{t('name_en')}}</label>
					</div>
					<div class="field-body">
						<div class="field">
							<p class="mr-auto control w-80" v-if="edit">
								<input id="name_en" name="name_en" class="has-text-primary input line-input is-primary has-text-centered" v-model="form.name_en" v-validate="{ required: true , min:6 ,max:30 }" :class="{'is-danger': errors.has('name_en') }" type="text" placeholder="">
								<span v-show="errors.has('name_en')" class="help is-danger">{{ errors.first('name_en') }}</span>
							</p>
							<p class="mr-auto control w-80 has-text-primary has-text-weight-bold" v-else>
								{{userObject.name_en}}
							</p>
						</div>
					</div>
				</div>
				<div class="field is-horizontal">
					<div class="field-label is-normal">
						<label class="label" for="categories">{{t('category')}}</label>
					</div>
					<div class="field-body">
						<div class="field">
							<div class="mr-auto control w-80 " v-if="edit && !userObject.category_id">
								<div class="select line-input is-primary is-fullwidth">
									<select class="text-align-select has-text-weight-normal" id="categories" name="categories" v-model="form.category_id" v-validate="'required'">
										<option selected="selected" disabled="disabled" :value="null">{{ t('choose_category')}}</option>
										<option v-for="category in inputCategories" :value="category.id">
											{{category.name}}
										</option>
									</select>
								</div>
								<span v-show="errors.has('categories')" class="help is-danger">{{ errors.first('categories') }}</span>
							</div>
							<p class="mr-auto control w-80 has-text-primary has-text-weight-bold" :class="{'has-text-centered': edit }" v-else>
								{{userObject.category}}
							</p>
						</div>
					</div>
				</div>
				<div class="field is-horizontal">
					<div class="field-label is-normal">
						<label class="label" for="name">{{t('phone')}}</label>
					</div>
					<div class="field-body">
						<div class="field ltr">
							<div class="mr-auto control w-80" v-if="edit">
								<div class="input-repeater">
									<template v-for="(input, index) in inputs">
										<div class="position-relative mb20">
											<button class="button input-repeater-remove-input has-text-primary p0" @click.prevent="removeInput(index)">
												<i class='fas fa-times-circle'></i>
											</button>
											<input v-validate="{ required: true , digits:11 }" :class="{'is-danger': errors.has('phone') }" class="input has-text-primary line-input is-primary has-text-centered" :index="index" :key="index" :input="input" :name="'phones['+index+']phone'" v-model="form.phones[index]">
											<span v-show="errors.has('phones['+index+']phone')" class="help is-danger">{{ t('wrong_number_message') }}</span>
										</div>
									</template>
									<div class='input-repeater-buttons has-text-centered'>
										<button class="button input-repeater-button-plus has-text-weight-bold has-text-warning" @click.prevent="plusInput">{{ t('add_phone') }}</button>
									</div>
								</div>
							</div>
							<p v-for="phone in JSON.parse(this.userObject.phones)" class="mr-auto control w-80 has-text-primary has-text-weight-bold" v-else>
								{{phone}}
							</p>
						</div>
					</div>
				</div>
				<div class="field is-horizontal">
					<div class="field-label is-normal">
						<label class="label" for="name">{{t('vodafone_cash')}}</label>
					</div>
					<div class="field-body">
						<div class="field ltr">
							<div class="mr-auto control w-80" v-if="edit">
								<input id="vodafone_cash" name="vodafone_cash" class="has-text-primary input line-input is-primary has-text-centered" v-model="form.vodafone_cash" v-validate="{ digits:11 }" :class="{'is-danger': errors.has('vodafone_cash') }" type="text" placeholder="">
								<span v-show="errors.has('vodafone_cash')" class="help is-danger">{{ errors.first('vodafone_cash') }}</span>
							</div>
							<div class="mr-auto control w-80 has-text-primary has-text-weight-bold" v-else>
								{{userObject.vodafone_cash}}
							</div>
						</div>
					</div>
				</div>
				<div class="field is-horizontal">
					<div class="field-label is-normal">
						<label class="label" for="name">{{t('website')}}</label>
					</div>
					<div class="field-body">
						<div class="field ltr">
							<div class="mr-auto control w-80" v-if="edit">
								<input id="website" name="website" class="has-text-primary input line-input is-primary has-text-centered" v-model="form.website" v-validate="{  url: {require_protocol: true } }" :class="{'is-danger': errors.has('website') }" type="text" placeholder="">
								<span v-show="errors.has('website')" class="help is-danger">{{ errors.first('website') }}</span>
							</div>
							<div class="mr-auto control w-80 has-text-primary has-text-weight-bold" v-else>
								{{userObject.website}}
							</div>
						</div>
					</div>
				</div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label" for="facebook">{{t('facebook')}}</label>
                    </div>
                    <div class="field-body">
                        <div class="field ltr">
                            <div class="mr-auto control w-80" v-if="edit">
                                <input id="facebook" name="facebook" class="has-text-primary input line-input is-primary has-text-centered" v-model="form.facebook" v-validate="{  url: {require_protocol: true } }" :class="{'is-danger': errors.has('facebook') }" type="text" placeholder="">
                                <span v-show="errors.has('facebook')" class="help is-danger">{{ errors.first('facebook') }}</span>
                            </div>
                            <div class="mr-auto control w-80 has-text-primary has-text-weight-bold" v-else>
                                {{userObject.facebook}}
                            </div>
                        </div>
                    </div>
                </div>
				<div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label" for="name">{{t('bio_ar')}}</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="mr-auto control w-80" v-if="edit">
                                <textarea id="bio_ar" name="bio_ar" class="has-text-primary input line-input is-primary has-text-centered" v-model="form.bio_ar" v-validate="{ min:20  }" :class="{'is-danger': errors.has('bio_ar') }" type="text" placeholder=""></textarea>
                                <span v-show="errors.has('bio_ar')" class="help is-danger">{{ errors.first('bio_ar') }}</span>
                            </div>
                            <div class="mr-auto control w-80 has-text-primary has-text-weight-bold" v-else>
                                {{userObject.bio_ar}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label" for="name">{{t('bio_en')}}</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="mr-auto control w-80" v-if="edit">
                                <textarea id="bio_en" name="bio_en" class="has-text-primary input line-input is-primary has-text-centered" v-model="form.bio_en" v-validate="{ min:20  }" :class="{'is-danger': errors.has('bio_en') }" type="text" placeholder=""></textarea>
                                <span v-show="errors.has('bio_en')" class="help is-danger">{{ errors.first('bio_en') }}</span>
                            </div>
                            <div class="mr-auto control w-80 has-text-primary has-text-weight-bold" v-else>
                                {{userObject.bio_en}}
                            </div>
                        </div>
                    </div>
                </div>
                <hr/>
                <h3 class="is-size-5 has-text-warning has-text-weight-bold mb30">{{t('address_data')}}</h3>
                <div class="field is-horizontal">
					<div class="field-label is-normal">
						<label class="label" for="full_address">{{t('address')}}</label>
					</div>
					<div class="field-body">
						<div class="field">
							<p class="mr-auto control w-80" v-if="edit">
								<input id="full_address" name="full_address" class="input has-text-primary line-input is-primary has-text-centered" v-model="form.full_address" v-validate="{ required: true , min:6 ,max:255 }" :class="{'is-danger': errors.has('full_address') }" type="text" placeholder="">
								<span v-show="errors.has('full_address')" class="help is-danger">{{ errors.first('full_address') }}</span>

							</p>
							<p class="mr-auto control w-80 has-text-primary has-text-weight-bold" v-else>
								{{userObject.full_address}}
							</p>
						</div>
					</div>
				</div>
				<div class="field is-horizontal">
					<div class="field-label is-normal">
						<label class="label" for="city">{{t('city_id')}}</label>
					</div>
					<div class="field-body">
						<div class="field">
							<div class="mr-auto control w-80" v-if="edit">
								<div class="select text-align-select line-input is-primary is-size-6 is-fullwidth mb15">
									<select id="city" name="city_id" v-model="form.city_id" v-validate="{ required: true }" :class="{'is-danger': errors.has('city_id') }" @change="getAreas">
										<option disabled selected :value="null">{{t('choose_city')}}</option>
										<option v-for="city in cities" :value="city.id">{{city.name}}</option>
									</select>
									<span v-show="errors.has('city_id')" class="help is-danger has-text-centered">{{ errors.first('city_id') }}</span>
								</div>
							</div>
							<div class="mr-auto control w-80 has-text-primary has-text-weight-bold" v-else>
								{{userObject.city}}
							</div>
						</div>
					</div>
				</div>
				<div class="field is-horizontal">
					<div class="field-label is-normal">
						<label class="label" for="area_id">{{t('area_id')}}</label>
					</div>
					<div class="field-body">
						<div class="field">
							<div class="mr-auto control w-80 mb30" v-if="edit">
								<div class="select text-align-select line-input is-primary is-size-6 is-fullwidth mb15">
									<select id="area_id" name="area_id" v-model="form.area_id" v-validate="{ required: true }" :class="{'is-danger': errors.has('area_id') }" >
										<option disabled selected :value="null">{{t('choose_state')}}</option>
										<option v-if="areas" v-for="area in areas" :value="area.id">{{area.name}}</option>
									</select>
									<span v-show="errors.has('area_id')" class="help is-danger has-text-centered">{{ errors.first('area_id') }}</span>
								</div>
							</div>
							<div class="mr-auto control w-80 has-text-primary has-text-weight-bold" v-else>
								{{userObject.state}}
							</div>
						</div>
					</div>
				</div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label" for="name">{{t('map')}}</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                        	<div class="mr-auto control w-80">
	                            <add-map
	                                :address="address"
	                                :latitude.sync="form.latitude"
	                                :longitude.sync="form.longitude"
	                                :editable="edit"
	                                map-height="300px"
	                            ></add-map>
	                        </div>
                        </div>
                    </div>
                </div>

                <hr/>
                <h3 class="is-size-5 has-text-warning has-text-weight-bold mb30">{{t('profile_data')}}</h3>

				<div class="field is-horizontal">
					<div class="field-label is-normal">
						<label class="label" for="name">{{t('mobile')}}</label>
					</div>
					<div class="field-body">
						<div class="field">
							<div class="mr-auto control w-80" v-if="edit">
								<input id="phone" name="phone" class="has-text-primary input line-input is-primary has-text-centered" v-model="form.phone" v-validate="{ required: true , numeric:true , length:11 }" :class="{'is-danger': errors.has('phone') }" type="text" placeholder="">
								<span v-show="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</span>

								<span ref="phone" class="hidden help is-danger"></span>
							</div>
							<div class="mr-auto control w-80 has-text-primary has-text-weight-bold" v-else>
								{{userObject.phone}}
							</div>
						</div>
					</div>
				</div>
				<div class="field is-horizontal">
					<div class="field-label is-normal">
						<label class="label" for="name">{{t('email')}}</label>
					</div>
					<div class="field-body">
						<div class="field">
							<div class="mr-auto control w-80" v-if="edit">
								<input id="email" name="email" class="has-text-primary input line-input is-primary has-text-centered" v-model="form.email" v-validate="{ required: true , email:true }" :class="{'is-danger': errors.has('email') }" type="text" placeholder="">
								<span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>

								<span ref="email" class="hidden help is-danger"></span>
							</div>
							<div class="mr-auto control w-80 has-text-primary has-text-weight-bold" v-else>
								{{userObject.email}}
							</div>
						</div>
					</div>
				</div>
				<div class="field is-horizontal" v-if="!edit">
					<div class="field-label is-normal">
						<label class="label" for="name">{{t('password')}}</label>
					</div>
					<div class="field-body">
						<div class="field" v-if="!edit">
							<div class="mr-auto control w-80 has-text-primary has-text-weight-bold">
								********
							</div>
						</div>
					</div>
				</div>
				<div class="field is-horizontal" v-if="edit">
					<div class="field-label is-normal">
						<label class="label" for="name">{{t('oldPassword')}}</label>
					</div>
					<div class="field-body">
						<div class="field">
							<p class="mr-auto control w-80">
								<input autocomplete="off" name="oldPassword" class="input has-text-primary line-input is-primary has-text-centered" v-model="form.password" v-validate="passwordRequired" :class="{'is-danger': errors.has('oldPassword') }" type="password">
								<span v-show="errors.has('oldPassword')" class="help is-danger">{{ errors.first('oldPassword') }}</span>
								<span ref="oldPassword" class="hidden help is-danger"></span>
							</p>
						</div>
					</div>
				</div>
				<div class="field is-horizontal" v-if="edit">
					<div class="field-label is-normal">
						<label class="label" for="name">{{t('new_password')}}</label>
					</div>
					<div class="field-body">
						<div class="field">
							<div class="mr-auto control w-80">
								<input name="new_password" class="input has-text-primary line-input is-primary has-text-centered" v-model="form.new_password" v-validate="newPassRequired" ref="new_password" :class="{'is-danger': errors.has('new_password') }" type="password">
								<span v-show="errors.has('new_password')" class="help is-danger">{{ errors.first('new_password') }}</span>

							</div>
						</div>
					</div>
				</div>
				<div class="field is-horizontal" v-if="edit">
					<div class="field-label is-normal">
						<label class="label" for="name">{{t('new_password_confirmation')}}</label>
					</div>
					<div class="field-body">
						<div class="field">
							<div class="mr-auto control w-80">
								<input name="new_password_confirmation" class="input has-text-primary line-input is-primary has-text-centered" v-model="form.new_password_confirmation" v-validate="newPassConfRequired" :class="{'is-danger': errors.has('new_password_confirmation') }" type="password">
								<span v-show="errors.has('new_password_confirmation')" class="help is-danger">{{ errors.first('new_password_confirmation') }}</span>
							</div>
						</div>
					</div>
				</div>

				<div class="has-text-centered mt40">
					<a href="#" class="button hvr-shutter-out-vertical is-rounded pl30 pr30 pt25 pb25" :class="[edit == true ? 'is-gery hvr-warning' : 'btn-warning hvr-primary']" @click.prevent="editFun()">
						{{edit == false ? t('edit'): t('cancel')}}
					</a>
					<button type="submit" class="button is-primary hvr-shutter-out-vertical hvr-primary is-rounded pl30 pr30 mr30" v-if="edit">{{t('save')}}</button>
				</div>
			</form>
		</div>


	</div>
</template>

<script>
	import AddMap from "../AddMap";
	import axios from 'axios';
	import arabic from 'vee-validate/dist/locale/ar';
	import { Validator , mapFields} from 'vee-validate';
	import trans from "../translation/user.json";
	export default {
		name: "MerchantProfile",
		components:{
			AddMap
		},
		props: {
			sitelocale:{
				type: String,
				required: true
			},
			method: {
				type: String,
				required: true
			},
			action: {
				type: String,
				required: true
			},

			merchantProfileUrl:{
				type: String,
				required: true
			},
			checkUniqueUrl:{
				type:String,
				required:true
			},
			cities:{
				type: Array,
				required: true
			},
			inputCategories:{
				type:Array,
				required:true
			},
			checkPass: {
				type: String,
				required: true
			},
			imageUrl : {
				type: String,
				required: true
			},

		},
		locales: trans,
		data: () => ({
			submitting: false,
			success: false,
			name: '',
			categories: [],
			form : {
				full_address: '',
				name_ar : '',
				name_en : '',
				phones:[],
				phone:'',
				email:'',
				password:'',
				new_password:'',
				new_password_confirmation:'',
				category_id : '',
				website:'',
                bio_ar:'',
                bio_en:'',
				latitude: '',
				longitude: '',
                area_id:'',
				vodafone_cash:''
			},
			areas:null,
			passwordFieldType: 'password',
			edit:false,
			requiredPass:false,
			openModal:false,
			inputs: [{value: null}],
			innerValues:[],
			user_id : null,
			userObject:null,
			address:{
				latitude:'',
				longitude:''
			}
		}),
		mounted() {
			this.$translate.setLang(this.sitelocale);
			axios.get(this.merchantProfileUrl)
				.then(response => {
					this.userObject = response.data.data;
					this.address.latitude = this.userObject.latitude !== null ? this.userObject.latitude :''
					this.address.longitude = this.userObject.longitude !== null ? this.userObject.longitude :''

				})
				.catch(error => {

				});
		},
		created() {
			this.$validator.localize('ar', {
				messages: arabic.messages,
				attributes: trans.ar,
			});
			this.$validator.localize('en', {
				attributes: trans.en,
			});
			Validator.localize(this.sitelocale);
		},
		methods: {
			editFun(){
				this.edit = !this.edit;
				if(this.edit == true){
					this.form.name_ar = this.userObject.name_ar;
					this.form.name_en = this.userObject.name_en;
					this.form.full_address = this.userObject.full_address;
					this.form.phones = this.userObject.phones != '' ? JSON.parse(this.userObject.phones) : [];
					this.form.category_id = this.userObject.category_id;
					this.inputs = this.form.phones;
					this.innerValues = this.form.phones;
                    this.form.bio_ar = this.userObject.bio_ar;
                    this.form.bio_en = this.userObject.bio_en;
                    this.form.website = this.userObject.website;
                    this.form.latitude = parseFloat(this.address.latitude);
                    this.form.longitude = parseFloat(this.address.longitude);
                    this.form.city_id = this.userObject.city_id;
                    this.form.area_id = this.userObject.area_id;
					this.form.vodafone_cash = this.userObject.vodafone_cash;
					this.form.email = this.userObject.email;
                    this.form.phone = this.userObject.phone;
					this.form.password = '';
					this.submitting = true;
                    this.getAreas();
					this.user_id = this.userObject.id;
				}
			},
			getAreas(){
				this.cities.map(city => {
					if (city.id == this.form.city_id) {
						this.areas = city.areas;
					}
				});
			},
			minusInput() {
				this.inputs.pop()
			},
			plusInput() {
				this.inputs.push('')
			},
			removeInput(i) {
				this.inputs.splice(i, 1);
			},
			inputchanged(event){
				console.log(event);
			},
			validateForm(){
				return this.$validator.validateAll().then((result) => {
					if(result && this.submitting){
						axios.post(this.action, this.form)
						.then( response => {
							this.showAlert('success' , ''  , response.data.data , '');
							this.success = true;
							this.edit = false;
							setTimeout(()=>{
								window.location.reload();
							}, 2000);

						})
						.catch(error => {
						    if (error.response.data.data) {
                                this.showAlert('error' , ''  , error.response.data.data , '');
                            } else {
                                this.showAlert('error',
                                    `${this.$translate.text('error_in_data')}`,
                                    'text',
                                    `<ul class="AlertList">`+Object.values(error.response.data.errors).map(error => `<li class="mb5 is-size-6">${error['message']}</li>`).join(' ')+`</ul>`
                                );
                            }
							this.success = false;

						})
						.then(()=>{
							this.submitting = false;
							setTimeout(()=>{
								this.success = false;
							}, 3500);
						});
					}
					else{
						console.log("noo");
					}
				});
			},
			checkUniq(data,fieldName){
				data =  data.target.value;
				let message = this.$refs[fieldName];
				if(!this.errors.has(fieldName)){
					axios.post(this.checkUniqueUrl, {'key' : fieldName, 'value' : data })
					.then(response => {
						this.submitting = true;
						this.$refs[fieldName].classList.add('hidden');
						message.innerHTML = "";
					})
					.catch(error => {
						this.submitting = false;
						message.innerHTML = error.response.data.message;
						message.classList.remove('hidden');
					});
				}
			},
			openMap(){
				this.openModal=true
			},
			checkPassword(data,route,fieldName){
				data =  data.target.value;
				if(data != '') {
					let message = this.$refs[fieldName];
					if(!this.errors.has(fieldName)){
						axios.post(route, {'password' : data })
						.then( response => {
							this.submitting = true;
							this.$refs[fieldName].classList.add('hidden');
							message.innerHTML = "";
						})
						.catch(error => {
							console.log(error);
							this.submitting = false;
							message.innerHTML = error.response.data.data;
							message.classList.remove('hidden');
						});
					}
				}

			},
			showAlert(type , title , text , html){
				this.$swal({
					type: type,
					title: title,
					text: text,
					html: html,
					showConfirmButton: false,
					timer:2000,
					customClass: type == 'success' ? 'swal2-is-success' : 'swal2-is-danger',
					backdrop: `
					rgba(36, 140, 204, 0.5)
					`
				});
			}
		},
		watch: {
			inputs: {
				handler(val) {
					this.$emit("input", val);
				},
				deep: true
			},
		},
		computed: {
			passwordRequired(){
				return this.form.password.length > 0 ? 'min:6|max:255' : '';
			},
			newPassRequired() {
				return this.form.password.length > 0 ? 'required|min:6|max:255' : '';
			},
			newPassConfRequired() {
				return this.form.new_password.length > 0 ? 'required|min:6|max:255|confirmed:new_password' : '';
			}
		}
	};
</script>
<style  lang="scss">
.hidden{
	display: none;
}
@media screen and (min-width: 769px), print{
	.merchant-profile-container{
		.field-label {
			flex-grow: 2;
		}
		.input-repeater{
			background: #f0f0f069;
			border-radius: 5px;
		}
	}
}

</style>
